import clsx from 'clsx';
import { Business } from 'react-ionicons';

const CompanyName = ({
  name,
  wrapperClasses,
  textClasses,
}: {
  name: string;
  wrapperClasses?: string;
  textClasses?: string;
}) => {
  return (
    <div
      className={clsx(
        'flex items-center gap-3 rounded-md text-content-base-default',
        wrapperClasses,
      )}
    >
      <Business width="20px" height="20px" color="currentColor" />
      <label
        className={clsx('font-bold text-content-base-default', textClasses)}
      >
        {name}
      </label>
    </div>
  );
};

export default CompanyName;
